import { matchType } from "../base/base-type";

export type ApplicationTaskBulkOperationResponse = {
  id: string;
};

export type ApplicationTask = {
  id: string;
  orgId: string;
  taskType: TaskType;
  taskDetails: ApplicationTaskDetail[];
  userName: string;
  createdAt: Date;
  updatedAt: Date;
};

export type ApplicationTaskDetail = {
  applicationId: string;
  taskStatus: TaskStatus;
  errCode?: ApplicationTaskErrorCodesLiterals;
};

export type TaskStatus = "NotYet" | "Success" | "Fail";
export type TaskType = "BulkIssuePdfFile" | "BulkUpdateTenantProcessResult";

const ApplicationTaskErrorCodes = [
  "application_is_not_file_issuable",
  "application_tenant_process_result_unchangeable",
  "pdf_field_render_failure",
  "outdated_version",
  "mail_sending_failure",
  "enqueue_failure",
  "procedure_invalid_status",
  "tenant_process_result_not_found",
  "invalid_tenant_process_result",
  "unspecified",
] as const;

type ApplicationTaskErrorCodesLiterals =
  (typeof ApplicationTaskErrorCodes)[number];

export const toErrorMessage = (code: ApplicationTaskErrorCodesLiterals) => {
  const generalErrorMsg =
    "処理に失敗しました。もう一度お試しいただき、再び同様のエラーになりましたらお問い合わせください。";

  return (
    matchType<ApplicationTaskErrorCodesLiterals, string>(code, {
      application_is_not_file_issuable:
        "対応ステータスを「処理中」に変更して、再度処理を行ってください。",
      application_tenant_process_result_unchangeable:
        "対応ステータスを「処理中」に変更して、再度処理を行ってください。",
      pdf_field_render_failure:
        "PDFの生成に失敗しました。申請項目の文字数が長く、枠からはみ出ている可能性があります。調整して再度お試しください。解決しない場合にはお問い合わせください。",
      outdated_version:
        "他の作業者によって申請内容が更新されました。再度処理を行ってください。",
      mail_sending_failure:
        "通知メールの送信に失敗しました。時間をおいてから再度お試しいただくか、メールアドレスの誤りがないかご確認ください。",
      enqueue_failure: generalErrorMsg,
      procedure_invalid_status:
        "申請に紐づく手続きが公開されているか確認してください。",
      tenant_process_result_not_found:
        "管理情報が設定されているか確認してください。",
      invalid_tenant_process_result:
        "管理情報が正しく入力されているか確認してください。",
      unspecified: generalErrorMsg,
    }) || generalErrorMsg
  );
};
